import FAQArticlePage from "./FAQArticle";

const data = {
  title: "Does my subscription automatically renew?",
  category: "Subscription Management",
  content: `Yes, subscriptions automatically renew at the end of each billing period unless cancelled.

How auto-renewal works:
- Your subscription will automatically renew on the same date each billing cycle (monthly, quarterly, or annually)
- The renewal charge will be processed using the same payment method on file
- You will receive a renewal reminder email 7 days before the renewal date

How to manage auto-renewal:
- You can cancel auto-renewal at any time before the renewal date
- Contact our support team to request cancellation of auto-renewal
- Once cancelled, your subscription will remain active until the end of the current period but will not renew

If you have any questions about your billing cycle or renewal dates, please contact our support team.

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function SMQ2Page() {
  return <FAQArticlePage data={data} />;
}